import type { ComponentProps } from 'react';

const DocumentOutlined = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 20.125C17.8438 20.125 18.125 19.8438 18.125 19.5V8.25H15C14.3086 8.25 13.75 7.69141 13.75 7V3.875H7.5C7.15625 3.875 6.875 4.15625 6.875 4.5V19.5C6.875 19.8438 7.15625 20.125 7.5 20.125H17.5ZM5 4.5C5 3.12109 6.12109 2 7.5 2H13.9648C14.6289 2 15.2656 2.26172 15.7344 2.73047L19.2695 6.26562C19.7383 6.73438 20 7.37109 20 8.03516V19.5C20 20.8789 18.8789 22 17.5 22H7.5C6.12109 22 5 20.8789 5 19.5V4.5Z"
        fill="#55657D"
      />
    </svg>
  );
};

export default DocumentOutlined;
